import {useAsyncRetry} from 'react-use';
import {getMediaList} from '@/api/media';

export function useMediaList(appId, type, query, current = 1, size = 10) {
    const {loading, value, retry} = useAsyncRetry(async () => {
        return await getMediaList(appId, type, query, current, size);
    }, [appId, type, query, current, size]);

    return {
        loading,
        retry,
        mediaRecords: value?.data?.records ?? [],
        total: value?.data?.total ?? 0,
    };
}
